import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
 
import apiServices from "../../services/apiServices";

// First, create the thunk
export const fetchAllbanks = createAsyncThunk(
  "bank_state/fetchAllbank",
  async () => {
    const response = await apiServices.get("banks");
    // console.log(response.data.data);
    return response.data.data;
  }
);
export const addbank = createAsyncThunk(
  "bank_state/addbank",
  async (data) => {
    const response = await apiServices.post("bank", data);
    // console.log(response.data.data);
    return response.data.data;
  }
);
export const updatebank = createAsyncThunk(
  "bank_state/updatebank",
  async (data) => {
    const response = await apiServices.put("bank/" + data.id, data);
    // console.log(response.data.data);
    return response.data.data;
  }
);

const initialState = {
  banks: [],
  error: "",
  editbank: {},
  bankUpdated: false,
  bankAdded: false,
};

let bankSlice = createSlice({
  name: "bank_state",
  initialState,
  reducers: {
    // insert actions here
    resetbank: function (state, action) {
      state.bankAdded = false;     
      state.loading = false;
    },
    resetUpdatebank: function (state, action) {
      state.bankUpdated = false;
      state.editbank = {};
      state.loading = false;
    },
    addEditedbank: (state, action) => {
      state.editbank = action.payload;
      console.log("edited bank set correctly", action.payload);
    },
    //action 2
    addNewbank: function (state, action) {
      // api call for the fetch all bank from server
      let { payload } = action;
      

      //return new state
      state.banks = [...state.banks, payload];

      console.log(state.banks);
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchAllbanks.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllbanks.fulfilled, (state, action) => {
      // Add user to the state array
     
      let banks = [];
      action.payload &&
        action.payload.map((x) => {
          let bank = {
            id: x._id,
            bankId: x.bankId,
            
            bankName: x.bankName,       
            bankCode: x.bankCode,
            accountName: x.accountName,
            accountNo: x.accountNo,
            swiftCode: x.swiftCode,
            bankAddress:x.bankAddress,
            routingNo:x.routingNo,
            country: x.country,
            status: x.status,
          };

          return banks.push(bank);
        });
      state.banks = banks;
      state.loading = false;
    });
    builder.addCase(fetchAllbanks.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in fetching banks";
    });

    // add all bank
    builder.addCase(addbank.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(addbank.fulfilled, (state, action) => {
      // Add user to the state array
      let bank = {
        id: action.payload._id,
        bankId: action.payload.bankId,  
        bankName: action.payload.bankName,       
        bankCode: action.payload.bankCode,
        accountName: action.payload.accountName,
        accountNo: action.payload.accountNo,
        swiftCode: action.payload.swiftCode,
        bankAddress:action.payload.bankAddress,
        routingNo:action.payload.routingNo,
        country: action.payload.country,
        status: action.payload.status,
      };
      state.banks = [...state.banks, bank];
      state.loading = false;
      state.bankAdded=true;

    });
    builder.addCase(addbank.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in adding bank";
      console.log(state.errorMessage);
    });
    // updatebank
    builder.addCase(updatebank.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updatebank.fulfilled, (state, action) => {
      // Add user to the state array
      let bank = {
        id: action.payload._id,
        bankId: action.payload.bankId,  
        bankName: action.payload.bankName,       
        bankCode: action.payload.bankCode,
        accountName: action.payload.accountName,
        accountNo: action.payload.accountNo,
        swiftCode: action.payload.swiftCode,
        bankAddress:action.payload.bankAddress,
        routingNo:action.payload.routingNo,
        country: action.payload.country,
        status: action.payload.status,
      };
      let temp = state.banks.filter((x) => x.id !== bank.id);
      temp.push(bank);
      state.banks = temp;
      state.loading = false;
      state.editbank = {};
      state.bankUpdated = true;
      
    });
    builder.addCase(updatebank.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in adding bank";
      console.log(state.errorMessage);
    });
  },
});
export const { resetUpdatebank, addEditedbank , resetbank} = bankSlice.actions;
export default bankSlice.reducer;
